module.exports = __webpack_public_path__ + "static/media/thematic.23011c3e.jpg";